import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import * as alerts from '../../_functions/alerts';
import { FieldConfig } from '../../_models/field.interface';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { CardDesafioComponent } from '../../_shared/components/card-desafio/card-desafio.component';

@Component({
  selector: 'app-desafios',
  templateUrl: './desafios.component.html',
  styleUrls: ['./desafios.component.scss'],
})
export class DesafiosComponent implements OnInit {
  obteveDesafios: boolean = false;
  menu: any[] = [];
  menuSelecionado: number = 0;
  desafios: any[] = [];
  desafiosFiltro: any[] = [];
  desafioStatus: boolean = false;
  membro: any = undefined;
  exibePopupAvisoHome: boolean = false;
  exibePopupAceiteComunicacao: boolean = false;
  exibeBotaoFecharAvisoHome: boolean = true;
  regulamento: string = '';
  regAbrirFecharPopupAvisoHome: FieldConfig[] = [];
  regConfigPopupAceiteComunicacao: FieldConfig[];
  regConfigPopupRegulamento: FieldConfig[] = [];
  carregandoDesafios: boolean = false;
  carregandoMembro: boolean = false;
  exibirPopupAceitarTodasMissoes: boolean = false;
  confirmaAceitarTodasMissoes: boolean = false;
  aceitandoDesafios: boolean = false;
  existeDesafioPendenteAceite: boolean = false;

  quantidadePorPagina: number = 8;
  paginaAtual: number = 1;
  existeProximaPagina: boolean = false;
  existePaginaAnterior: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private authService: AuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.carregarMembroLogado();
  }

  @ViewChildren('cardComponent') cards: QueryList<CardDesafioComponent>;

  destroyChild() {
    if (this.cards != undefined) {
      var arrCards = this.cards.toArray();

      for (let index = 0; index < arrCards.length; index++) {
        arrCards[index].ngOnDestroy();
      }
      this.filtroDesafios();
    }
  }

  public definirSelecionado(i: number): void {
    this.menuSelecionado = i;
    this.paginaAtual = 1;
    this.destroyChild();
  }

  public filtroDesafios(): any[] {
    window.onload = function () {
      if (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          navigator.userAgent
        )
      ) this.quantidadePorPagina = 4;
    }
    if (
      this.desafios != undefined &&
      this.desafios != null &&
      this.desafios.length > 0
    ) {
      this.desafiosFiltro = _.filter(this.desafios, (desafio: any) => {
        this.desafioStatus = desafio.statusId == this.menuSelecionado;
        return desafio.statusId == this.menuSelecionado;
      });

      this.existeProximaPagina = false;
      this.existePaginaAnterior = this.paginaAtual == 1 ? false : true;

      if (
        this.desafiosFiltro.length >
        this.paginaAtual * this.quantidadePorPagina
      )
        this.existeProximaPagina = true;

      if (this.paginaAtual == 1)
        this.desafiosFiltro = this.desafiosFiltro.slice(
          0,
          this.quantidadePorPagina
        );
      else
        this.desafiosFiltro = this.desafiosFiltro.slice(
          (this.paginaAtual - 1) * this.quantidadePorPagina,
          (this.paginaAtual - 1) * this.quantidadePorPagina +
          this.quantidadePorPagina
        );

      return this.desafiosFiltro.sort(
        (a, b) =>
          new Date(b.fimDesafio).getTime() - new Date(a.fimDesafio).getTime()
      );
    }

    return [];
  }

  filtroMenuDesafio(menu): any {
    const index = this.menu.indexOf(menu);
    this.menu.splice(index, 1);
  }

  private carregarMembroLogado(): void {
    this.carregandoMembro = true;

    this.fidelidadeService.obterMembro().subscribe({
      next: (res: any) => this.processarSucessoObterMembro(res),
      error: (err: any) => this.processarFalhaObterMembro(err),
    });
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
    this.authService.LocalStorage.salvarMembro(res);
    this.carregandoMembro = false;

    if (this.membro?.tipoStatus === 7 || this.membro?.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    } else this.obterDesafios();
  }

  private processarFalhaObterMembro(err: any): void {
    console.error('Ocorreu um erro ao obter o membro', err);
    this.carregandoMembro = false;
  }

  obterDesafios() {
    if (this.menuSelecionado !== undefined && this.menuSelecionado !== null) {
      this.carregandoDesafios = true;

      this.fidelidadeService.obterDesafios(this.membro.cpf).subscribe({
        next: (res: any) => this.processarSucessoObterDesafios(res),
        error: (err: any) => this.processarFalhaObterDesafios(err),
      });
    }
  }

  processarSucessoObterDesafios(res: any) {
    this.obteveDesafios = true;
    const desafios: any[] = [];
    let possuiAtivas = false;
    let possuiConcluidas = false;
    let possuiExpiradas = false;

    if (res && res.length > 0) {
      this.existeDesafioPendenteAceite = res[0].existeDesafioPendenteAceite;
    }

    res = _.orderBy(res, (desafio: any) => desafio.indexGrupoMissaoDependente);

    for (let desafio of res) {
      let countMissoesDependente = 0;
      let ehMissaoDependente = false;
      let listaMissoesDependente = [];

      if (
        desafio.idGrupoMissaoDependente != null &&
        desafio.idGrupoMissaoDependente != ''
      ) {
        const desafioDependenteJaExibido = desafios.some(
          (x) =>
            x.idGrupoMissaoDependente == desafio.idGrupoMissaoDependente &&
            x.statusId == 0
        );

        if (desafioDependenteJaExibido) continue;

        listaMissoesDependente = res.filter(
          (x) => x.idGrupoMissaoDependente == desafio.idGrupoMissaoDependente
        );

        countMissoesDependente = listaMissoesDependente.length;
        ehMissaoDependente = true;
      }

      desafios.push({
        id: desafio.id,
        titulo: desafio.nomeDesafio,
        descricao: desafio.descricao,
        valorPontosRecompensa: desafio.xp,
        valorCacausRecompensa: desafio.pontos,
        idTipo: desafio.idTipo,
        inicioDesafio: desafio.dataInicio,
        fimDesafio: desafio.dataFim,
        porcentagem: desafio.desafiosMembros[0]?.porcentagemFeita,
        link: desafio.link !== null ? desafio.link : '',
        desafioAceito: desafio.desafioAceito,
        caminhoImagem: desafio.caminhoImagem,
        caminhoImagemMobile: desafio.caminhoImagemMobile,
        statusId: desafio.statusId,
        descricaoDeAceite: desafio.descricaoDeAceite,
        ehMissaoDependente: ehMissaoDependente,
        countMissoesDependente: countMissoesDependente,
        idGrupoMissaoDependente: desafio.idGrupoMissaoDependente,
        indexGrupoMissaoDependente: desafio.indexGrupoMissaoDependente,
        exibeAgrupamento: false,
        listaMissoesDependente: listaMissoesDependente,
      });
    }

    possuiAtivas = desafios.some(function (d) {
      return d.statusId === 0;
    });
    possuiConcluidas = desafios.some(function (d) {
      return d.statusId === 1;
    });
    possuiExpiradas = desafios.some(function (d) {
      return d.statusId === 2;
    });

    const menu: any[] = [];

    if (possuiAtivas) menu.push({ id: 0, descricao: 'Ativas' });
    if (possuiConcluidas) menu.push({ id: 1, descricao: 'Concluídas' });
    if (possuiExpiradas) menu.push({ id: 2, descricao: 'Expiradas' });

    this.menu = menu;

    this.desafios = _.orderBy(desafios, (desafio: any) => desafio.id);
    this.desafios.sort(
      (a, b) =>
        new Date(b.fimDesafio).getTime() - new Date(a.fimDesafio).getTime()
    );

    this.filtroDesafios();
    this.carregandoDesafios = false;
  }

  private processarFalhaObterDesafios(err: any): void {
    this.obteveDesafios = false;
    console.error('Ocorreu um erro ao obter os desafios', err);
    this.carregandoDesafios = false;
  }

  aceitarDesafio(id: number): void {
    const desafio = this.desafios.find((x) => x.id === id);
    if (desafio) {
      desafio.desafioAceito = true;
    }
  }

  abrirPopupAceitarTodasMissoes(): void {
    this.exibirPopupAceitarTodasMissoes = true;
  }

  cancelarAceitarTodasMissoes(): void {
    this.exibirPopupAceitarTodasMissoes = false;
  }

  aceitarTodasMissoes(): void {
    this.aceitandoDesafios = true;

    this.fidelidadeService.aceitarTodosDesafios(this.membro.id).subscribe({
      next: (res: any) => this.processarSucessoAceitarTodosDesafios(res),
      error: (err: any) => this.processarFalhaAceitarTodosDesafios(err),
    });
  }

  processarSucessoAceitarTodosDesafios(res: any): void {
    this.aceitandoDesafios = false;
    this.exibirPopupAceitarTodasMissoes = false;
    this.obterDesafios();
    alerts.exibirToast('success', 'Missões iniciadas com sucesso!');
  }

  processarFalhaAceitarTodosDesafios(res: any): void {
    this.aceitandoDesafios = false;
    alerts.exibirToast('error', 'Erro ao iniciar todas as missões!');
  }

  voltar() {
    this.paginaAtual -= 1;
    this.filtroDesafios();
    this.scrollToDuvidas();
  }

  avancar() {
    this.paginaAtual += 1;
    this.filtroDesafios();
    this.scrollToDuvidas();
  }

  public scrollToDuvidas() {
    const scrollElem = document.querySelector('#menu') as HTMLElement;
    const margin =
      20 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const scrollToPosition =
      scrollElem.getBoundingClientRect().top + window.scrollY - margin;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth',
    });
  }
}
